/**
 * ワイド型の文字の指定。公開画面（埋め込み）・管理画面のプレビュー・管理画面の編集で共通。
 *
 * 管理画面のふつうの画面と同じ「端末の標準フォント」にそろえる（Tailwind の font-sans と同じ並び）。
 * Mac・iPhone は San Francisco＋ヒラギノ、Windows は Segoe UI＋游ゴシック で表示される。
 * 以前は Inter → Noto Sans JP の順だったが、埋め込みは Inter を読み込まないので Noto Sans JP、
 * 管理画面は Inter を読み込んでいるので Inter になり、プレビューと公開画面で数字の形が食い違っていた
 */
export const WIDE_FONT_FAMILY =
  'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
